<template>
  <div class="menu">
    <div v-if="languageCode=='zh'" @click="goPath()" class="top">行业应用</div>
    <div v-else @click="goPath()" class="top">Application</div>
    <ul>
      <li
        @click="goPath(index, item)"
        :class="mebuActive == index ? 'active' : ''"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
import { applyDomainList } from "../../../api/index";
export default {
  data() {
    return {
      list: [],
      active: null,
      languageCode:'zh'
    };
  },
  props: {
    mebuActive: "",
  },
  methods: {
    goPath(index, item) {
      const currentPath = this.$route.path;
      const currentQuery = this.$route.query;
      const targetPath = this.getLocalizedPath("/apply"); // 例如 "/zh/apply"
      const isOnTargetPage = currentPath === targetPath;

      if (item) {
        this.$parent.active = index;
        this.$emit("changeBreadcrumb", item);

        const needNavigate =
          !isOnTargetPage || currentQuery.applyDomainId != item.applyDomainId;
        if (needNavigate) {
          this.$router.push({
            path: targetPath,
            query: { applyDomainId: item.applyDomainId },
          });
        }
      } else {
        this.$parent.active = -1;
        this.$emit("changeBreadcrumb", { name: "", id: "" });

        const needNavigate = !isOnTargetPage || Object.keys(currentQuery).length > 0;
        if (needNavigate) {
          this.$router.push({ path: targetPath });
        }
      }
    },
    // 获取带当前语言的完整路径
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
  },
  mounted() {
    // this.active = this.$route.query.id
    const lang = this.$i18nState.locale; // ✅ 正确的语言获取方式
    this.languageCode = lang
    applyDomainList({ languageCode: lang == "zh" ? "zh-CN" : "en-US" }).then((res) => {
      this.list = res.rows;
    });
    if (this.active) {
      this.$emit("changeBreadcrumb", this.list[this.active].name);
    }
  },
};
</script>
<style lang="scss" scoped>
.top {
  background: url("../../../assets/img13.png") #1f3b6d;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.active {
  background-color: #476da7;
  color: #d1d1d1;
}

.menu {
  width: 250px;
}

ul {
  li {
    width: 250px;
    line-height: 86px;
    border-bottom: 1px solid #cfcfcf;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }

  li:last-child {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/apply/compontents/menu.vue